import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";

function MuiTextField(props) {
  const { disabled, ...otherProps } = props;

  return (
    <TextField
      className={disabled ? "mui-textfield-readonly" : ""}
      disabled={disabled}
      {...otherProps}
      InputLabelProps={{
        shrink: true,
        sx: {
          "&.Mui-focused": {
            color: "#C8102E"
          }
        }
      }}
      InputProps={{
        sx: {
          "&:before": {
            borderBottom: "1px solid rgba(0, 0, 0, 0.12) !important"
          },
          "&:after": {
            borderBottom: "2px solid #C8102E"
          }
        }
      }}
    />
  );
}

MuiTextField.defaultProps = {
  disabled: false,
};

MuiTextField.propTypes = {
  disabled: PropTypes.bool,
};

export default MuiTextField;
